import React, { createContext, useContext } from 'react';

/**
 * @typedef {Object} DashboardShellValue
 * @property {string} homePath - Brand / default in-app home for this shell
 * @property {string} workspacePath - Primary work surface (e.g. project list dashboard)
 * @property {string} profilePath
 * @property {string | null} projectBasePath - e.g. '/student/project' or '/faculty/project'
 * @property {string | null} codingRoot - e.g. '/admin' or '/faculty' when coding tracker is mounted under that prefix
 * @property {string | null} codingActivityPath - full path to coding activity log
 */

const DashboardShellContext = createContext(null);

export function DashboardShellProvider({ value, children }) {
  return (
    <DashboardShellContext.Provider value={value}>{children}</DashboardShellContext.Provider>
  );
}

/** @returns {DashboardShellValue | null} */
export function useDashboardShell() {
  return useContext(DashboardShellContext);
}
